export { default, meta } from "/Users/huffn/dev/repos/personal/wild-beyond-witchlight/app/routes/getting-started.jsx";